module.exports = __webpack_public_path__ + "img/clean.49f5942f.png";